import React, {Component} from 'react'
import moment from 'moment';
import 'moment/locale/zh-cn';
import DeliveryStep from '../../components/step/delivery-step'
import {
    Table, Row, Col, Button, Input, message, Popconfirm, InputNumber, Form, DatePicker, AutoComplete,
    Tabs, Timeline, Select
} from 'antd'
import './delivery-detail.less'
import axios from 'axios'
import {getOrderShort, getOrderTrails, getOrderDelivery, baseUrl, reqDeviceList, reqCabinetTypes} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
import authorize from "../../components/authorize/authorize";
import ajax from "../../api/ajax";
import RouteStepViewForm from "../route/route-step-view";
import {ReactBingmaps} from "react-bingmaps";
import {convertToOptions} from '../../components/options'
import { PACKAGE_TYPE} from "../../utills/constants";
import TrackShortInfoView from './track-short-info-v'
const AuthButton = authorizeBase(Button)
const AuthPopconfirm = authorizeBase(Popconfirm)
moment.locale('zh-cn');
let orderId = '';
const {TextArea} = Input;
const {TabPane} = Tabs;
const {Option} = AutoComplete;
const EditableContext = React.createContext();
class ComA extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<a {...this.props}></a>)
    }
}
const AuthA = authorizeBase(ComA)
const pattern = /[A-Za-z]{4}\d{7}/;
const pattern2 = /^\d{6}$/;
const pattern3 = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
const editFactoryCodes = new Map();
class EditableCell extends React.Component {
    state = {
        autoDataSource: [],
        pageNum: 1,
        pageSize: 10000
    }
    getInput = () => {
        const {autoDataSource} = this.state
        if (this.props.inputType === 'number') {
            return <InputNumber />;
        } else if (this.props.inputType === 'date') {
            return <DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>;
        } else if (this.props.inputType === 'date2') {
            return <DatePicker format="YYYY-MM-DD"/>;
        } else if (this.props.inputType === 'auto') {
            return <AutoComplete
                dataSource={autoDataSource.map(this.renderOption)}
                optionLabelProp="text"
                style={{width: 200}}
                onSearch={this.onSearch}
                onFocus={this.onFocus}
                onSelect={this.onSelect}
            />;
        } else if (this.props.inputType === 'cabinetType') {
            return <Select getPopupContainer={triggerNode => triggerNode.parentNode}
                           style={{width: '100%'}}>
                {this.props.options.map(o => {
                    return <Option key={o.cabinetType} value={o.cabinetType}>{o.cabinetTypeName}</Option>
                })}
            </Select>
        } else if (this.props.inputType === 'packageCode') {
            return <Select getPopupContainer={triggerNode => triggerNode.parentNode}
                           style={{width: '100%'}}>
                {convertToOptions(PACKAGE_TYPE)}
            </Select>
        }
        return <Input />;
    };
    renderOption = (item) => {
        return (
            <Option key={item.value} text={item.value} code={item.factoryCode}>
                <div className="global-search-item">
        <span className="global-search-item-desc">
         {item.value} {item.factoryName}
        </span>
                </div>
            </Option>
        );
    }
    onSearch = value => {
        this.getProducts(value);
    }
    onFocus = value => {
        this.getProducts(value);
    }
    onSelect = (value, option) => {
        this.getProducts(value);
        const factoryCode = option.props.code;
        const props = this.props;
        editFactoryCodes.set(props.record.key, factoryCode);
    }

    getProducts = async (deviceId) => {
        const {pageNum, pageSize} = this.state
        const values = {}
        values.deviceId = deviceId;
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqDeviceList(values)
        if (result.code === 200) {
            let res = result.data.rows;
            if (res && res.length > 0) {
                res = res.map((obj) => {
                    return {value: obj.deviceId, factoryCode: obj.factoryCode, factoryName: obj.factoryCodeName};
                })
                this.setState({
                    autoDataSource: res
                })
            } else {
                this.setState({
                    autoDataSource: []
                })
            }
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    getInitValue = (record, dataIndex) => {
        if (this.props.inputType === 'date' && record[dataIndex]) {
            return moment(record[dataIndex], 'YYYY-MM-DD HH:mm:ss');
        } else if (this.props.inputType === 'date2' && record[dataIndex]) {
            return moment(record[dataIndex], 'YYYY-MM-DD');
        }
        return record[dataIndex];
    }
    validateBoxNo = (rule, value, callback) => {
        if (rule.field === 'boxNo' && (!!value)) {
            if (value.length !== 11) {
                callback('集装箱号为11位');
            }
            if (!(pattern.test(value))) {
                callback('集装箱号前4位为字母,后7位为数字')
            }
        }
        if (rule.field === 'factoryNo' && (!!value)) {
            if (!(pattern2.test(value))) {
                callback('厂封号为6位数字');
            }
        }
        if (rule.field === 'boxWeight' && (!!value)) {
            if (!(pattern3.test(value))) {
                callback('皮重为纯数字, 最多保留2位小数')
            }
        }
        callback();
    };
    renderCell = ({getFieldDecorator}) => {
        const {
            editing,
            dataIndex,
            title,
            record,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{margin: 0}}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: (dataIndex == 'boxNo' || dataIndex === 'cabinetType' || dataIndex == 'factoryNo' || dataIndex === 'boxWeight' || dataIndex == 'optDt' || dataIndex == 'note' || dataIndex == 'truckNo') ? true : false,
                                    message: `请填写 ${title}!`,
                                }, {
                                    validator: this.validateBoxNo
                                }
                            ],
                            initialValue: this.getInitValue(record, dataIndex),
                        })(this.getInput())}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}


let cabinetType = '';

class DeliveryEdit extends Component {
    constructor(props) {
        super(props)
        this.columns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            }, {
                title: '运单号',
                dataIndex: 'deliveryNo',
                editable: true,
            }, {
                title: '中车号',
                dataIndex: 'realPlateNo',
                editable: true,
            }, {
                title: '跨境电商车板号',
                dataIndex: 'virtualPlateNo',
                editable: true,
            }, {
                title: '请车时间',
                dataIndex: 'pleaseCarDt',
                editable: true,
            }, {
                title: '装箱地点',
                dataIndex: 'boxLocation',
                editable: true,
            }, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    const {editingKeyBox, dataSource} = this.state;
                    const editable = this.isEditingBox(record);
                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <AuthA authority="delivery_edit:delivery_save"
                                       onClick={() => this.save2(form, record.key)}
                                       style={{marginRight: 8}}
                                >
                                    保存
                                </AuthA>
                            )}
                          </EditableContext.Consumer>
                          <Popconfirm title="是否确定取消?" onConfirm={() => this.cancel2(record.key)}>
                            <a>取消</a>
                          </Popconfirm>
                        </span>
                    ) : (
                        <span> <AuthA authority="delivery_edit:delivery_save" disabled={editingKeyBox !== ''}
                                      onClick={() => this.edit2(record.key)}
                                      style={{marginRight: 8}}>
                                        修改
                                    </AuthA>
                        </span>
                    );
                }
            }
        ];
        this.columns2 = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: '集装箱号',
                dataIndex: 'boxNo',
                editable: true,
            },
            {
                title: '箱型',
                dataIndex: 'cabinetType',
                editable: true,
                width: 150,
                render: (text, record) => {
                    const array = this.state.cabinetTypes.filter(o => o.cabinetType === text);
                    if (array.length > 0) {
                        return array[0].cabinetTypeName
                    }
                }
            },
            {
                title: 'GPS编号',
                dataIndex: 'trailNo',
                editable: true,
                key: 'trailNo',
            }, {
                title: '厂封号',
                dataIndex: 'factoryNo',
                editable: true,
            }, {
                title: '皮重 (kg)',
                dataIndex: 'boxWeight',
                editable: true,
            }, {
                title: '包装种类',
                dataIndex: 'packageCode',
                editable: true,
                width: 180,
                render: (text, record) => {
                    return PACKAGE_TYPE[text]
                }
            }, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    const {editingKey, dataSource} = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <AuthA authority="delivery_edit:delivery_save"
                                       onClick={() => this.save(form, record.key)}
                                       style={{marginRight: 8}}
                                >
                                    保存
                                </AuthA>
                            )}
                          </EditableContext.Consumer>
                          <Popconfirm title="是否确定取消?" onConfirm={() => this.cancel(record.key)}>
                            <a>取消</a>
                          </Popconfirm>
                        </span>
                    ) : (
                        <span> <AuthA authority="delivery_edit:delivery_save" disabled={editingKey !== ''}
                                      onClick={() => this.edit(record.key)}
                                      style={{marginRight: 8}}>
                                        修改
                                    </AuthA>
                            <AuthPopconfirm authority="delivery_edit:delivery_delete" title="是否确定删除?"
                                            onConfirm={() => this.handleDelete(record.key)}>
                            <AuthA authority="delivery_edit:delivery_delete">删除</AuthA>
                        </AuthPopconfirm>
                        </span>
                    );
                }
            }
        ];

        this.vehicleColumns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (this.state.page2 - 1) * this.state.pageSize2}</span>
                )
            },
            {
                title: '车牌号',
                dataIndex: 'truckNo',
                editable: true,
            },
            {
                title: '司机姓名',
                width: '100',
                dataIndex: 'name',
                editable: true,
            },
            {
                title: '身份证号码',
                width: '100',
                dataIndex: 'identification',
                editable: true,
            },
            {
                title: '手机号码',
                width: '100',
                dataIndex: 'phone',
                editable: true,
            }, {
                title: '操作',
                fixed: 'right',
                width: 100,
                dataIndex: 'opt',
                render: (text, record) => {
                    const {vehicleEditingKey, vehicleDataSource} = this.state;
                    const editable = this.isEditingVehicle(record);
                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <AuthA authority="delivery_edit:car_save"
                                       onClick={() => this.saveVehicle(form, record.key)}
                                       style={{marginRight: 8}}
                                >
                                    保存
                                </AuthA>
                            )}
                          </EditableContext.Consumer>
                          <Popconfirm title="是否确定取消?" onConfirm={() => this.cancelVehicle(record.key)}>
                            <a>取消</a>
                          </Popconfirm>
                        </span>
                    ) : (
                        <span> <AuthA authority="delivery_edit:car_save" disabled={vehicleEditingKey !== ''}
                                      onClick={() => this.editVehicle(record.key)}
                                      style={{marginRight: 8}}>
                                        修改
                                    </AuthA>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDeleteVehicle(record.key)}>
                            <AuthA authority="delivery_edit:car_delete">删除</AuthA>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];
        this.state = {
            order: {
                orderNo: '',
                containerNum: '',
                createdDt: '',
                deliveryDt: '',
                start: '',
                destination: ''
            },
            originAdd: '',
            destinaAdd: '',
            deliveryDt: '',
            dataSource: [],
            count: 0,
            editingKey: '',
            editingKeyBox: '',
            editingKey2: '',
            destinationCity: '',
            noteEditingKey: '',
            noteDataSource: [],
            page: 1,
            pageSize: 10,
            noteCount: 0,
            total: 0,
            vehicleEditingKey: '',
            vehicleDataSource: [],
            page2: 1,
            pageSize2: 10,
            vehicleCount: 0,
            total2: 0,
            stepEditable: true,
            autoAllData: [],
            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            rowId: 1,
            mapData: [],
            stepDescription: [],
            currentTrailNo: '',
            pageNote: 1,
            totalNote: 0,
            orderNodes: [],
            cabinetTypes: [],
        }
    }

    getCabinetTypes = async () => {
        const result = await reqCabinetTypes();
        if (result.code === 200) {
            this.setState({cabinetTypes: result.data});
        }
    };
    isEditing = record => record.key === this.state.editingKey;
    isEditingBox = record => record.key === this.state.editingKeyBox;
    cancel = (key) => {
        this.setState({editingKey: ''});

        //厂家号
        editFactoryCodes.delete(key);
    };

    cancel2 = (key) => {
        this.setState({editingKeyBox: ''});
    };

    handleDelete = key => {
        const dataSource = [...this.state.dataSource];
        const index = dataSource.findIndex(item => key === item.key);
        const item = dataSource[index]
        if (item && item.id) {
            let id = item.id;
            axios.delete(baseUrl + '/api/v1/p/deliveryDel', {params: {id}}).then((res) => {
                var result = res.data;
                if (result.code === 200) {
                    this.setState({dataSource: dataSource.filter(item => item.key !== key)});
                    message.success(result.message);
                } else {
                    message.error(result.message)
                    return false;
                }
            })
        } else {
            this.setState({dataSource: dataSource.filter(item => item.key !== key)});
        }
    };

    getAllProducts = async (deviceId) => {
        const values = {}
        values.deviceId = deviceId;
        values.pageNum = 1;
        values.pageSize = 10000;
        let result = await reqDeviceList(values)
        if (result.code === 200) {
            let res = result.data.rows;
            if (res && res.length > 0) {
                this.setState({
                    autoAllData: res
                })
            } else {
                this.setState({
                    autoAllData: []
                })
            }
        }

    }

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const {autoAllData,} = this.state
            const trailNo = row.trailNo;
            //厂家号
            const factoryCode = editFactoryCodes.get(key);
            row.factoryCode = factoryCode;
            editFactoryCodes.delete(key);
            //厂家号
            const filterData = autoAllData.filter(item => item.deviceId === trailNo)
            if ((filterData && filterData.length > 0) || trailNo == null || trailNo.length === 0) {
                const newData = [...this.state.dataSource];
                const index = newData.findIndex(item => key === item.key);
                if (index > -1) {
                    const item = newData[index];
                    const values = {
                        boxNo: row.boxNo,
                        cabinetType: row.cabinetType,
                        trailNo: row.trailNo,
                        factoryNo: row.factoryNo,
                        boxWeight: row.boxWeight,
                        packageCode: row.packageCode,
                        factoryCode: row.factoryCode,
                    }
                    if (!factoryCode) {
                        values.factoryCode = item.factoryCode;
                    }
                    values.id = item.id;
                    values.orderid = orderId;
                    if (values && values.id) {
                        axios.put(baseUrl + '/api/v1/p/deliveryUpdate', values).then((res) => {
                            newData.splice(index, 1, {
                                ...item,
                                ...values,
                            });
                            var result = res.data;
                            if (result.code === 200) {
                                this.setState({dataSource: newData, editingKey: ''});
                                message.success(result.message);
                            } else {
                                message.error(result.message)
                                return false;
                            }
                        })
                    } else {
                        axios.post(baseUrl + '/api/v1/p/deliverySave', values).then((res) => {
                            var result = res.data;
                            if (result.code === 201) {
                                values.id = result.data.id;
                                newData.splice(index, 1, {
                                    ...item,
                                    ...values,
                                });
                                this.setState({dataSource: newData, editingKey: ''});
                                message.success(result.message);
                            } else {
                                message.error(result.message)
                                return false;
                            }
                        })
                    }
                } else {
                    newData.push(row);
                    this.setState({dataSource: newData, editingKey: ''});
                }
            } else {
                message.error('请选择存在的GPS编号或者不填写GPS编号')
            }
        });
    }

    save2(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.dataSource];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                const values = {
                    deliveryNo: row.deliveryNo,
                    realPlateNo: row.realPlateNo,
                    virtualPlateNo: row.virtualPlateNo,
                    boxLocation: row.boxLocation,
                }
                values.id = item.id;
                values.orderid = orderId;
                values.pleaseCarDt = !!row.pleaseCarDt ? moment(row.pleaseCarDt).format('YYYY-MM-DD HH:mm:ss') : null;
                values.saveForDevice = 'N';
                if (values && values.id) {
                    axios.put(baseUrl + '/api/v1/p/deliveryUpdate', values).then((res) => {
                        newData.splice(index, 1, {
                            ...item,
                            ...values,
                        });
                        var result = res.data;
                        if (result.code === 200) {
                            this.setState({dataSource: newData, editingKeyBox: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message)
                            return false;
                        }
                    })
                } else {
                    axios.post(baseUrl + '/api/v1/p/deliverySave', values).then((res) => {
                        var result = res.data;
                        if (result.code === 201) {
                            values.id = result.data.id;
                            newData.splice(index, 1, {
                                ...item,
                                ...values,
                            });
                            this.setState({dataSource: newData, editingKeyBox: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message)
                            return false;
                        }
                    })
                }
            } else {
                newData.push(row);
                this.setState({dataSource: newData, editingKeyBox: ''});
            }
        });
    }

    edit(key) {
        this.setState({editingKey: key});
    }

    edit2(key) {
        this.setState({editingKeyBox: key});
    }

    handleAdd = () => {
        const {count, dataSource} = this.state;
        const newData = {
            key: count,
            deliveryNo: '',
            boxNo: '',
            trailNo: '',
        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: count + 1,
        });
    };

    //第二张表格
    isEditing2 = record => record.key === this.state.editingKey2;
    // cancel2 = () => {
    //     this.setState({editingKey2: ''});
    // };
    //
    //
    // edit2(key) {
    //     this.setState({editingKey2: key});
    // }

    isEditingVehicle = record => record.key === this.state.vehicleEditingKey;
    cancelVehicle = () => {
        this.setState({vehicleEditingKey: ''});
    };

    handleDeleteVehicle = key => {
        const dataSource = [...this.state.vehicleDataSource];
        const index = dataSource.findIndex(item => key === item.key);
        const item = dataSource[index]
        const dataSourceLength = dataSource.length - 1;
        const {page2, pageSize2} = this.state;
        if (item && item.id) {
            let id = item.id;
            axios.delete(baseUrl + '/api/v1/p/orderVehicleDel', {params: {id}}).then((res) => {
                var result = res.data;
                if (result.code === 200) {
                    const dataLength = dataSourceLength % pageSize2
                    if (dataLength === 0) {
                        const totalPage2 = dataSourceLength / pageSize2
                        if (totalPage2 <= page2 && page2 != 1) {
                            this.setState({
                                page: totalPage2
                            })
                        }
                    }
                    this.setState({vehicleDataSource: dataSource.filter(item => item.key !== key)});
                    message.success(result.message);
                } else {
                    message.error(result.message)
                    return false;
                }
            })
        } else {
            const dataLength = dataSourceLength % pageSize2
            if (dataLength === 0) {
                const totalPage2 = dataSourceLength / pageSize2
                if (totalPage2 <= page2 && page2 != 1) {
                    this.setState({
                        page2: totalPage2
                    })
                }
            }
            this.setState({vehicleDataSource: dataSource.filter(item => item.key !== key)});
        }
    };

    saveVehicle(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.vehicleDataSource];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                row.orderId = orderId;
                row.id = item.id;
                if (row && row.id) {
                    axios.put(baseUrl + '/api/v1/p/orderVehicleUpdate', row).then((res) => {
                        newData.splice(index, 1, {
                            ...item,
                            ...row,
                        });
                        var result = res.data;
                        // console.log('先执行', result)
                        if (result.code === 200) {
                            this.setState({vehicleDataSource: newData, vehicleEditingKey: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message)
                            return false;
                        }
                    })
                } else {
                    axios.post(baseUrl + '/api/v1/p/orderVehicleSave', row).then((res) => {
                        var result = res.data;
                        // console.log('先执行', result)
                        if (result.code === 201) {
                            row.id = result.data.id;
                            newData.splice(index, 1, {
                                ...item,
                                ...row,
                            });
                            this.setState({vehicleDataSource: newData, vehicleEditingKey: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message)
                            return false;
                        }
                    })
                }
            } else {
                newData.push(row);
                this.setState({vehicleDataSource: newData, vehicleEditingKey: ''});
            }
        });
    }


    editVehicle(key) {
        this.setState({vehicleEditingKey: key});
    }


    handleAddVehicle = () => {
        const {vehicleCount, vehicleDataSource} = this.state;
        const newData = {
            key: vehicleCount,
            truckNo: '',
            name: '',
            identification: '',
            phone: ''
        };
        const datasource = [];
        datasource.push(newData)
        vehicleDataSource.forEach(function (item) {
            datasource.push(item)
        });
        this.setState({
            vehicleDataSource: datasource,
            vehicleCount: vehicleCount + 1,
        });
    };

    getVehicle = (pageNum) => {
        this.setState({
            page: pageNum,// 保存pageNum, 让其它方法可以看到
            pageSize: 10
        })

        axios.get(baseUrl + '/api/v1/p/orderVehicleList', { // 配置对象
            params: {orderId: orderId, pageNum: this.state.page2, pageSize: 10000} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        total2: result.data.total,
                        vehicleDataSource: data,
                        vehicleCount: result.data.total
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });

    }

    componentDidMount() {
        this.getAllProducts('');
        this.getCabinetTypes();
        authorize("delivery_edit:trail_edit").then(() => {
            this.setState({
                stepEditable: true
            })
        }).catch(() => {
            this.setState({
                stepEditable: false
            })
        })
        orderId = this.props.location.state.orderId;

        const getOrderShortFunc = async (id) => {
            let result = await getOrderShort(id)
            if (result.code === 200) {
                var data = result.data;
                cabinetType = data.cabinetType;
                data.start = data.originCountry + (data.originProvince ? data.originProvince : '') + data.originCity;
                data.destination = data.destinationCountry + (data.destinationProvince ? data.destinationProvince : '') + data.destinationCity;
                const originAdd = data.originCountry + ' ' + data.originCity
                const destinaAdd = data.destinationCountry + ' ' + data.destinationCity
                this.setState({
                    order: data,
                    destinationCity: data.destinationCity,
                    originAdd,
                    destinaAdd
                })
                if (data.routeType === 'N') {
                    this.getOrderNodes(orderId);
                }
            } else {
                message.error(result.message)
            }
        }
        getOrderShortFunc(orderId);
        axios.get(baseUrl + '/api/v1/p/orderDelivery', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].key = i;
                        data.push(result.data[i]);
                    }
                    this.setState({
                        dataSource: data,
                        count: result.data.length,
                        mapData: result.data,
                        center: [],
                        infoboxesWithPushPins: [],
                        polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}}
                    })
                    this.timer_two(data[0].trailNo, data[0].factoryCode);
                    this.getRightOrderTrails(data[0].trailNo, data[0].factoryCode)
                    this.setState({currentTrailNo: data[0].trailNo})
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
        this.getNotes(1);
        this.getVehicle(1);
    }

    timer_two = (trailNo, factoryCode) => setTimeout(
        () => {
            this.getOrderTrails(trailNo, factoryCode)
        },
        2000
    );
    getOrderTrails = async (trailNo, factoryCode) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo, factoryCode, type: 'normal', orderId})
            if (result.code === 200 && result.data.length > 0) {
                let ret = []
                let ret2 = []
                result.data.forEach((item) => {
                    //console.log(item)
                    let address =
                        '位置:' + item.address + '<br/>' +
                        '设备号:' + item.trailNo + '<br/>' +
                        '到达时间:' + item.activeDt + '<br/>' +
                        '经度:' + item.longitude + '<br/>' +
                        '纬度:' + item.latitude + '<br/>' +
                        '温度(摄氏):' + item.uTemperature + '<br/>' +
                        '电量(%):' + item.uBattery + '<br/>' +
                        '信号强度:' + item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "mouseover",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                        "infoboxAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        },
                        "pushPinAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        }
                    })
                    ret2.push([item.latitude, item.longitude])
                });

                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 4}},
                });
            } else if (result.code === 200) {
                this.setState({
                    center: [],
                    infoboxesWithPushPins: [],
                    polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                });
            } else {
                message.error(result.message)
            }
        }
    }
    handleClickItem = (des) => {
        if (des.sts === 'Y') {
            this.scrollInto("step" + des.id);
            this.setState({
                center: [des.latitude, des.longitude],
                regularPolygons: [
                    {
                        "center": [des.latitude, des.longitude],
                        "radius": 6,
                        "points": 6,
                        "option": {fillColor: "rgba(0,0,0,0.4)", strokeThickness: 2}
                    }
                ],
            });
        }
    };
    getRightOrderTrails = async (trailNo, factoryCode) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo, factoryCode, type: 'all', orderId})
            if (result.code === 200 && result.data.length > 0) {
                let description = []
                result.data.forEach(function (item) {
                    let sesObj = {
                        id: item.id,
                        sts: item.sts,
                        activeDt: item.activeDt,
                        address: item.address,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        uTemperature: item.uTemperature,
                        uSignalstrength: item.uSignalstrength

                    }
                    description.push(sesObj)
                });
                this.setState({
                    stepDescription: description
                });
            } else if (result.code === 200) {
                this.setState({
                    stepDescription: []
                });
            } else {
                message.error(result.message)
            }
        }
    }
    tabChange = (key) => {
        const trailNo = key.split(',')[0];
        const factoryCode = key.split(',')[1];
        this.getOrderTrails(trailNo, factoryCode);
        this.getRightOrderTrails(trailNo, factoryCode);
        this.setState({currentTrailNo: key.trailNo})
    }
    steDescription = (obj) => {
        if (obj) {
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.longitude}</div>
                <div>纬度:{obj.latitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }

    };
    scrollInto = (id) => {
        let anchorElement = document.getElementById(id);
        if (anchorElement) {
            this.setState({
                activeId: id,
            })
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        } else {
            console.log(id + " not found")
        }
    }
    setColletDt = (date) => {
        if (date) {
            this.setState({
                deliveryDt: date
            })
        }

    }

    exportTrain = () => {
        window.location.href = baseUrl + '/api/v1/p/opt/export?orderId=' + orderId
    }

    getNotes = (pageNum) => {
        this.setState({
            pageNote: pageNum
        })

        axios.get(baseUrl + '/api/v1/p/orderNoteList', { // 配置对象
            params: {orderId: orderId, pageNum: pageNum, pageSize: this.state.pageSize} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        result.data.rows[i].optDt = (result.data.rows[i].optDt ? result.data.rows[i].optDt.substr(0, 10) : '')
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        totalNote: result.data.total,
                        noteDataSource: data,
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });

    }
    getOrderNodes = async (orderId) => {
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/api/v1/p/yg/orderNodes", {orderId});
        if (result && result.data) {
            let nodes = [];
            if (nodes) {
                nodes = result.data.nodeVos.sort((a, b) => {
                    return a.indx - b.indx
                })
            }
            this.setState({
                orderNodes: nodes,
                routeIOType: result.data.type,
            })
        } else {
            message.error("轨迹信息不存在！")
        }
        this.setState({
            loading: false
        })
    }

    render() {
        const {mapData, stepDescription, dataSource, vehicleDataSource, cabinetTypes, order} = this.state;
        const components = {
            body: {
                cell: EditableCell,
            },
        };
        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            let inputType = 'text';
            if (col.dataIndex === 'trailNo') {
                inputType = 'auto'
            } else if (col.dataIndex === 'pleaseCarDt') {
                inputType = 'date'
            } else {
                inputType = 'text'
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditingBox(record),
                }),
            };
        });
        const columns2 = this.columns2.map(col => {
            let options;
            if (!col.editable) {
                return col;
            }
            let inputType = 'text';
            if (col.dataIndex === 'trailNo') {
                inputType = 'auto'
            } else if (col.dataIndex === 'pleaseCarDt') {
                inputType = 'date'
            } else if (col.dataIndex === 'cabinetType') {
                inputType = 'cabinetType';
                options = cabinetTypes;
            } else if (col.dataIndex === 'packageCode') {
                inputType = 'packageCode'
            } else {
                inputType = 'text'
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType,
                    options,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });

        const vehicleColumns = this.vehicleColumns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditingVehicle(record),
                }),
            };
        });
        return (
            <div className='order-info info box-shadow padding-20'>
                <div className="head-title">
                    <span className='title'>物流详情</span>
                </div>
                <br/>
                <TrackShortInfoView order={order}/>
                <div className='info-item'>
                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>集装箱信息</div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <EditableContext.Provider value={this.props.form}>
                            <Table columns={columns2}
                                   bordered
                                   components={components}
                                   rowClassName={() => 'editable-row'}
                                   pagination={ false }
                                   dataSource={dataSource}
                                   size="middle"/>
                        </EditableContext.Provider>
                    </div>


                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>物流信息
                                {/*<AuthButton authority="delivery_edit:delivery_add" onClick={this.handleAdd} type='primary' style={{float:'right'}}>新增</AuthButton>*/}
                            </div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <EditableContext.Provider value={this.props.form}>
                            <Table columns={columns}
                                   bordered
                                   components={components}
                                   rowClassName={() => 'editable-row'}
                                   pagination={ false }
                                   dataSource={dataSource}
                                   size="middle"/>
                        </EditableContext.Provider>
                    </div>

                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>车辆信息
                                <AuthButton authority="delivery_edit:car_add" onClick={this.handleAddVehicle}
                                            type='primary' style={{float: 'right'}}>新增</AuthButton>
                            </div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <EditableContext.Provider value={this.props.form}>
                            <Table columns={vehicleColumns}
                                   components={components}
                                   scroll={{x: 'auto'}}
                                   bordered
                                   rowClassName={() => 'editable-row'}
                                   pagination={{
                                       onChange: (page2, pageSize2) => {
                                           this.setState({page2, pageSize2})
                                       }
                                   }
                                   }
                                   dataSource={vehicleDataSource}
                                   size="middle"/>
                        </EditableContext.Provider>
                    </div>
                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>客户说明</div>
                        </div>
                    </div>
                    <div style={{marginTop: '20px'}}>
                        <TextArea style={{height: '100px', resize: 'none'}} readonly={true}
                                  value={order.clientExplain}/>
                    </div>

                    <br/>
                    <div className="info-item-title">
                        轨迹信息
                        <Button type='primary' authority="delivery_edit:trail_export" onClick={this.exportTrain}
                                style={{float: 'right'}}>导出</Button>
                    </div>
                    <div className="info-item-content">
                        {order.routeType === 'N' ?
                            <RouteStepViewForm nodes={this.state.orderNodes} routeType={this.state.routeIOType}
                                               readOnly={true} loading={this.state.loading}
                                               reload={this.getOrderNodes}/>
                            : <DeliveryStep {...this.props} action={this.state.stepEditable ? 'edit' : null}
                                            setColletDt={this.setColletDt}/>}
                    </div>
                    <div className="info-item-title">
                        轨迹展示
                    </div>
                    {
                        mapData ? <Tabs type="card" style={{marginTop: '10px'}} onChange={this.tabChange}>
                            {mapData.map(t => {
                                return t.trailNo ?
                                    <TabPane tab={t.trailNo} key={t.trailNo + ',' + t.factoryCode}></TabPane> : ''
                            })}
                        </Tabs> : null
                    }

                    <div className='track-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={8}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins }
                                regularPolygons={this.state.regularPolygons}
                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {stepDescription ? <Timeline>
                                {stepDescription.map(des => (
                                    <Timeline.Item id={"step" + des.id} key={"step" + des.id}><p
                                        onClick={() => this.handleClickItem(des)}
                                        style={this.state.activeId === ("step" + des.id) ? {
                                            color: "#2975d5",
                                            paddingTop: 3
                                        } : (des.sts !== 'N' ? {
                                            color: "rgba(0, 0, 0, 0.9)",
                                            paddingTop: 3
                                        } : {color: "rgba(0,0,0,.45)", paddingTop: 3})}>{this.steDescription(des)}</p>
                                    </Timeline.Item>
                                ))}
                            </Timeline> : null}

                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
export default Form.create()(DeliveryEdit);